export const GET_MY_USER = 'GET_MY_USER'
export const TOGGLE_MENU = 'TOGGLE_MENU'
export const SET_MENU_CHROME_HIDDEN = 'SET_MENU_CHROME_HIDDEN'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const SET_USER_NOTIFICATION_SETTINGS = 'SET_USER_NOTIFICATION_SETTINGS'
export const SET_ADMIN_NOTIFICATION_SETTINGS = 'SET_ADMIN_NOTIFICATION_SETTINGS'
export const SET_TOTAL_NOTIFICATIONS_COUNT = 'SET_TOTAL_NOTIFICATIONS_COUNT'
